const prop = (key, defaults) => ({
    get() {
        if (defaults) {
            return defaults;
        }
        throw new Error(`Key '${key}' is not configured.`);
    },
    set(value) {
        Object.defineProperty(this, key, {
            set() {
                throw new Error(`Key '${key}' is already configured.`);
            },
            get() {
                return value;
            }
        });
    }
});
export const config = Object.create(null, {
    defaultStrategy: prop('defaultStrategy', null)
});
